import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error);
  },
);

export const extractWordCount = (payload) => {
  return api.post('/extract-word-count', payload);
}

export const compareUrls = (payload) => {
  return api.post('/compare-urls', payload);
}

export const extractTopics = (payload) => {
  return api.post('/extract-topics', payload);
}

export const extractImages = (payload) => {
  return api.post('/extract-images', payload);
}

export const downloadImages = (payload) => {
  return api.post('/download-images', payload, {
    responseType: 'blob',
  });
}

export const extractBodyContent = (payload) => {
  return api.post('/extract-body-content', payload);
}

export const extractUrls = (payload) => {
  return api.post('/extract-urls', payload);
}

export const extractHeadings = (payload) => {
  return api.post('/extract-headings', payload);
}

export default {
  extractWordCount,
  compareUrls,
  extractTopics,
  extractImages,
  extractBodyContent,
  extractUrls,
  extractHeadings
}
